export const MENU_ACCUEIL = '__ACCUEIL__';
export const MENU_TEST = '__TEST__';
export const MENU_SETTINGS = '__SETTINGS__';
export const MENU_ENCAISSEMENT = 'encaissement';
export const MENU_ENCAISSEMENT_DIRECT = 'encaissement_direct';
export const MENU_PAYEUR = 'payeur';
export const MENU_CONSTITUTION = 'constitution';
export const MENU_LISTES = 'listes';
export const MENU_LISTE_PAYEUR = 'liste_payeur';
export const MENU_LISTE_CYCLE = 'liste_cycle';
export const MENU_LISTE_FACTURE = 'liste_facture';
export const MENU_LISTE_RECU = 'liste_recu';
// Menu "Reçus" autonome : point de menu de 1er niveau affiché en régie autonome, à la place du
// dépliable "Cycles, factures et reçus". Route distincte de /listes/recus pour un ciblage sans
// ambiguïté par le masquage conditionnel (cf. MenuVisibility).
export const MENU_RECUS_AUTONOME = 'recus_autonome';
export const MENU_PRELEVEMENTS = 'prelevements';
export const MENU_ARRETES = 'arretes';
export const MENU_ARRETE_JOURNALIER = 'arretes_journalier';
export const MENU_ARRETE_PERIODIQUE = 'arretes_periodique';
export const MENU_ARRETE_ANNUEL = 'arretes_annuel';
export const MENU_VERSEMENT_TRESOR = 'versement_tresor';
export const MENU_POINTAGE_BORDEREAUX = 'pointage_bordereaux';
export const MENU_BORDEREAUX_REMISE = 'bordereaux_remise';
export const MENU_IMPAYES = 'impayes';
export const MENU_CONTROLES = 'controles';
export const MENU_CONTROLES_TEMPORAIRE = 'controles_temporaire';
export const MENU_CONTROLES_ETATS_RECAPITULATIFS = 'controles_etats_recapitulatifs';
export const MENU_CONTROLES_ETATS_CONTROLE = 'controles_etats_controle';

export const LOCATIONS = {
  [MENU_ACCUEIL]: '/',
  [MENU_TEST]: '/test-fiche',
  [MENU_SETTINGS]: '/parametres',
  [MENU_ENCAISSEMENT]: '/encaissement',
  [MENU_ENCAISSEMENT_DIRECT]: '/encaissement-direct',
  [MENU_PAYEUR]: '/payeurs',
  [MENU_CONSTITUTION]: '/constitution',
  [MENU_LISTES]: '/listes',
  [MENU_LISTE_PAYEUR]: '/listes/payeur',
  [MENU_LISTE_CYCLE]: '/listes/cycles',
  [MENU_LISTE_FACTURE]: '/listes/factures',
  [MENU_LISTE_RECU]: '/listes/recus',
  [MENU_RECUS_AUTONOME]: '/recus',
  [MENU_PRELEVEMENTS]: '/factures-prelevees',
  [MENU_ARRETES]: '/arretes',
  [MENU_ARRETE_JOURNALIER]: '/arretes/journaliers',
  [MENU_ARRETE_PERIODIQUE]: '/arretes/periodique',
  [MENU_ARRETE_ANNUEL]: '/arretes/annuel',
  [MENU_VERSEMENT_TRESOR]: '/versements-remises',
  [MENU_POINTAGE_BORDEREAUX]: '/versements-remises/controle-bordereaux',
  [MENU_BORDEREAUX_REMISE]: '/versements-remises/bordereaux-remise',
  [MENU_IMPAYES]: '/impayes',
  [MENU_CONTROLES]: '/controles',
  [MENU_CONTROLES_TEMPORAIRE]: '/controles/temporaire',
  [MENU_CONTROLES_ETATS_RECAPITULATIFS]: '/controles/etats-recapitulatifs',
  [MENU_CONTROLES_ETATS_CONTROLE]: '/controles/etats-controle',
};

export const DROITS_REGISSEUR = [
  MENU_ACCUEIL,
  MENU_TEST,
  MENU_SETTINGS,
  MENU_ENCAISSEMENT,
  MENU_ENCAISSEMENT_DIRECT,
  MENU_PAYEUR,
  MENU_CONSTITUTION,
  MENU_LISTES,
  MENU_LISTE_PAYEUR,
  MENU_LISTE_CYCLE,
  MENU_LISTE_FACTURE,
  MENU_LISTE_RECU,
  MENU_RECUS_AUTONOME,
  MENU_PRELEVEMENTS,
  MENU_ARRETES,
  MENU_ARRETE_JOURNALIER,
  MENU_ARRETE_PERIODIQUE,
  MENU_ARRETE_ANNUEL,
  MENU_VERSEMENT_TRESOR,
  MENU_POINTAGE_BORDEREAUX,
  MENU_BORDEREAUX_REMISE,
  MENU_IMPAYES,
  MENU_CONTROLES,
  MENU_CONTROLES_TEMPORAIRE,
  MENU_CONTROLES_ETATS_RECAPITULATIFS,
  MENU_CONTROLES_ETATS_CONTROLE,
];

export const DROITS_REGISSEUR_SUPPLEANT = DROITS_REGISSEUR;

export const DROITS_AGENT_GUICHET = [MENU_ACCUEIL, MENU_ENCAISSEMENT, MENU_ENCAISSEMENT_DIRECT];
